/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Magento_Wishlist/js/view/wishlist',[
    'jquery',
    'uiComponent',
    'Magento_Customer/js/customer-data'
], function ($, Component, customerData) {
    'use strict';

    return Component.extend({
        /** @inheritdoc */
        initialize: function () {
            this._super();
            this.wishlist = customerData.get('wishlist');
            var sections = ['wishlist'];
            customerData.reload(sections, true);

            $(document).ready(function () {
                setTimeout(function () {
                    if (typeof JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist !== 'undefined'
                        && JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist.counter !== null) {
                        var wishlistCounter = JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist.counter;
                        $('.wishlist .counter').html(wishlistCounter);
                    }
                }, 1500);
            });
        }
    });
});

